import * as React from 'react';
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import ShoppingCartIcon  from '@mui/icons-material/ShoppingCart';
import { useCartContext } from "../../contexts/CartContext";

const StyledBadge = styled(Badge)(() => ({
  '& .MuiBadge-badge': {
    right: -3,
    top: 13,
    padding: '0 4px',
  }
}));

export default function CartBadge() {
  const { cart, setShowCart } = useCartContext();

  return (
    <IconButton aria-label="cart" onClick={() => setShowCart(true)}>
      <StyledBadge badgeContent={cart.length} color="secondary">
        <ShoppingCartIcon sx={{ color: "white" }} />
      </StyledBadge>
    </IconButton>
  );
}
